import type { CardImplementationDto } from "../../types/CardImplementationDto";
import type { CardImplementationEntity } from "../../types/CardImplementationEntity";

export const CardImplementationEntityToDto = ({ ...rest }: Readonly<CardImplementationEntity>): CardImplementationDto => {
    return { ...rest };
};
